import options from './thing-status.component';

export default {
    selector: 'dtAsThingStatus',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-status/index.js